/* src/app/private/components/contact-group/add-contact-in-group/add-contact-in-group.component.scss */
::ng-deep .disabled-row {
  opacity: 0.5;
  pointer-events: none;
  background-color: #f5f5f5 !important;
  cursor: not-allowed !important;
}
::ng-deep .disabled-row td {
  color: #999 !important;
}
::ng-deep .disabled-row .p-checkbox {
  opacity: 0.6;
  pointer-events: none;
}
::ng-deep .disabled-row .p-checkbox .p-checkbox-box {
  background-color: #e0e0e0 !important;
  border-color: #ccc !important;
}
/*# sourceMappingURL=add-contact-in-group.component.css.map */
